import { motion, AnimatePresence } from 'motion/react';
import { SectionType, sectionConfig } from './SectionHeader';
import { SectionTooltip } from './SectionTooltip';

interface StickySectionHeaderProps {
  currentSection: SectionType | null;
  topBarHeight?: number;
}

export function StickySectionHeader({
  currentSection,
  topBarHeight = 60,
}: StickySectionHeaderProps) {
  // Don't render if no section is active
  if (!currentSection) return null;

  const config = sectionConfig[currentSection];
  const backgroundColor =
    currentSection === 'express'
      ? '#f3ebff'
      : currentSection === 'para-voce'
        ? '#D1FAE7'
        : '#F0F2F5';

  return (
    <motion.div
      key={currentSection}
      initial={{ opacity: 0, y: -4 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -4 }}
      transition={{
        duration: 0.12,
        ease: [0.25, 0.1, 0.25, 1],
      }}
      style={{
        position: 'fixed',
        top: `${topBarHeight}px`,
        left: 0,
        right: 0,
        zIndex: 25, // Below the filter blur overlay (z-30) but above content
        backgroundColor: backgroundColor,
        borderBottom: '1px solid var(--border)',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingTop: '12px',
        paddingBottom: '12px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
        margin: '0 auto',
      }}
    >
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          {config.icon}
          <h3
            style={{
              fontSize: 'var(--text-sm)',
              fontWeight: 'var(--font-weight-semibold)',
              lineHeight: '1.5',
              color: config.color,
            }}
          >
            {config.title}
          </h3>
        </div>
        <SectionTooltip
          content={config.tooltip}
          color={config.color}
        />
      </div>
    </motion.div>
  );
}
